// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar:after,
.off-canvas-sidebar:after {
  background: #001628;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  display: none;
}
.sidebar-mini .sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  display: block;
}
.logo-normal {
  text-align: left;
  margin-left: 15px;
}
.logo-normal img {
  width: 150px;
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after,
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  background-color: #0fa0cf30;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  text-transform: capitalize;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  font-weight: 500;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  font-size: 14px;
}
.nav li a img {
  width: 24px;
  display: inline;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  display: inline;
  margin-left: 15px;
}
.nav li a {
  display: flex;
}
.sidebar-mini .sidebar .nav p,
.off-canvas-sidebar .nav p {
  /* display: none; */
}
.main-panel > .content {
  padding: 0 15px 30px;
  margin-top: 75px;
}
.data-table {
  background: #fff;
  padding: 15px;
  border-radius: 15px;
}
.data-table h5 {
  display: none;
}
.table-search-bar input {
  color: #222;
  background-color: #eef2f3;
  border: 1px solid #eef2f3;
}
.table th,
.table td {
  border-top: 1px solid #eef2f3;
}

.react-bootstrap-table-pagination-total {
  margin-left: 15px;
}
.pagination .page-item.active > .page-link,
.pagination .page-item.active > .page-link:focus,
.pagination .page-item.active > .page-link:hover {
  background-color: #0fa0cf;
  border-color: #0fa0cf;
  color: #ffffff;
}
.table > thead > tr > th {
  background: #0fa0cf17;
  color: #0fa0cf;
}
.navbar.navbar-transparent {
  border-bottom: none;
}
.table-avatar {
  border-radius: 5px;
  border: 1px solid;
  border-color: #eef2f3;
  height: 40px;
  width: 40px;
  overflow: hidden;
  margin-right: 10px;
  display: inline-block;
}
.table-avatar img {
  max-width: 100%;
  height: auto;
}
.table-avatar-name span {
  display: inline-block;
}
.p-0 {
  padding: 0px !important;
}
.max-width-100 {
  max-width: 100%;
}
.full-width {
  width: 100%;
}
.table-search-bar .form-control {
  color: #222;
  background-color: #eef2f3;
  border: 1px solid #eef2f3;
}
.table td,
.table th {
  border-top: 1px solid #f0f2f5;
  vertical-align: middle;
}
.table td p {
  margin-bottom: 0px !important;
}
.ant-dropdown-button button {
  background: #f0f2f5;
  border: none;
}
.ant-dropdown-button button:hover,
.ant-dropdown-button button:focus,
.ant-dropdown-button button:active {
  background: #f0f2f5;
  border: none;
  color: #0fa0cf;
}

.total-spinner {
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.total-spinner-backdrop {
  z-index: 99;
  width: 100%;
  height: 100%;
  position: absolute;
  background: #ffffff99;
}
.ant-spin-dot-item {
  background: #0fa0cf;
}
.react-bootstrap-table .anticon-eye svg {
  color: #0fa0cf;
  font-size: 16px;
  cursor: pointer;
}
.view-name {
  cursor: pointer;
}
.view-name:hover {
  color: #0fa0cf;
}
.data-table .table thead th {
  border-bottom: none;
}
.data-table .table th {
  border-top: none;
}
.capitalize {
  text-transform: capitalize;
}
.react-bootstrap-table-pagination-total {
  margin-left: 15px;
}
.react-bootstrap-table {
  max-width: 100%;
  overflow: scroll;
}
.fa.fa-star.filled {
  color: #0fa0cf;
}
.btn,
.navbar .navbar-nav > a.btn {
  background: #00000020;
}
.card-stats .icon-big {
  height: 30px;
  width: 50px;
  min-height: 50px;
  font-size: 0px;
}
.navbar.navbar-transparent {
  background: #fff !important;
}
.react-loading-skeleton {
  background-color: #f7f7f7 !important;
  background-image: linear-gradient(
    90deg,
    #fbfbfb,
    #fbfbfb,
    #fbfbfb
  ) !important;
}
/* .ant-tabs-tab.ant-tabs-tab-active {
  background: #0fa0cf;
  padding: 12px 16px;
  border-radius: 5px;
}
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.ant-tabs-tab:hover {
  color: #0fa0cf;
} */
.card-component {
  margin: 0px 10px 10px;
  padding: 15px;
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}
.card-component:hover {
  box-shadow: 0 6px 10px -4px #0fa0cf36;
  /* background: #f7fdff; */
}
.avatar-holder {
  height: 75px;
  background-position: center;
  width: 100%;
  background-size: cover;
  padding: 2px;
  position: relative;
  border: 1px solid #eaeaea;
  border-radius: 10px;
}
.card-row {
  margin: 10px 0px;
}
.text-holder {
  padding: 0px 10px;
}
.text-holder h6 {
  margin: 0px;
  font-size: 16px;
  font-weight: normal;
  text-transform: capitalize;
}
.location-text,
.gender-text,
.dob-text,
.date-text {
  color: #7d7d7d;
  font-size: 12px;
}
.location-text svg,
.gender-text svg,
.dob-text svg,
.date-text svg {
  color: #45bd5b;
}
.status-text {
  margin-top: 7px;
  margin-bottom: 0px;
}
.card-component .alpha-dummy-avatar {
  height: 100%;
  background: #bee2c0;
  width: 100%;
  text-shadow: 1px 1px 4px #33894d47;
}
.card-component .alpha-dummy-avatar p {
  font-size: 32px;
  margin-bottom: 0px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-component .ant-btn-group.ant-dropdown-button button:first-child {
  display: none;
}
.card-component .ant-btn-group.ant-dropdown-button {
  position: absolute;
  right: 15px;
  bottom: 15px;
}
.card-component
  .ant-btn.ant-btn-default.ant-btn-icon-only.ant-dropdown-trigger {
  height: 22px;
  line-height: 12px;
}
.item-details-modal .patient .profile-image {
  margin-top: 0px;
}
.item-details-modal .patient .profile-info {
  margin-top: 20px;
}
.appointment-details .ant-modal-body {
  padding-top: 0px;
}

.ant-tabs-ink-bar {
  background: #0fa0cf;
}
.appointment-details .ant-modal-footer {
  display: none;
}
.modal-row .modal-column:nth-child(even) {
  background: #eaf5fa;
}
.modal-row {
  border: 1px solid #eaf5fa;
}
.modal-row .modal-column {
  padding: 5px;
}

.report-list {
  color: #0fa0cf;
  /* list-style: none; */
  /* padding-left: 10px; */
}
.report-list a {
  color: #0fa0cf;
}
.appointment-details .ant-tabs-tab.ant-tabs-tab-active {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  padding: 0;
  padding: initial;
  border-radius: 0;
  border-radius: initial;
}
.hospitals-tab .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.hospitals-tab .ant-tabs-ink-bar {
  background: transparent;
}
.list-count {
  margin-bottom: 0px;
  margin-left: 10px;
}
.paginator {
  position: relative;
  text-align: right;
}
.paginator .previous,
.paginator .next {
  color: #0fa0cf;
  display: inline-block;
  height: 25px;
  width: 25px;
  border-radius: 5px;
  text-align: center;
  background: transparent;
  border: 1px solid #0fa0cf;
  cursor: pointer;
  margin-right: 10px;
}
.paginator .previous:hover,
.paginator .next:hover {
  background: #0fa0cf;
  color: #fff;
}
.paginator .previous.disabled,
.paginator .next.disabled {
  background: #dfdfdf;
  color: #b1afaf;
  border-color: #b1afaf;
}
.alpha-dummy-avatar,
.table-avatar {
  cursor: pointer;
}
.appointments-container {
  display: flex;
  flex-direction: column;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  opacity: 1;
}
.sidebar .nav li.active {
  background: #0fa0cf0f;
}
.today-appointments {
  height: 385px;
  max-height: 385px;
  overflow: scroll;
}
.today-appointments.lab {
  height: 4355px;
  max-height: 435px;
}
.today-appointments .appointment-card {
  margin-bottom: 5px;
  border-radius: 7px;
  width: 100%;
  position: relative;
  font-size: 12px;
  background: #f6f8f9;
  padding: 10px;
  border: 1px solid #eaeaea;
  cursor: pointer;
}
.today-appointments .appointment-card.lab {
  font-size: 14px;
}
.today-appointments .appointment-card:hover {
  box-shadow: 0px 1px 4px rgb(0 0 0 / 15%);
  transition: box-shadow 0.3s ease-in-out;
}
.appointment-card .appointment-card-header {
  width: 100%;
}
.appointment-card .appointment-action-buttons {
  padding: 10px 0px 0px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.appointment-card .appointment-action-buttons button {
  /* padding: 3px 0px; */
  flex: auto;
  height: auto;
}
.appointment-card .patient-avatar {
  height: 30px;
  background: #0fa0cf;
  width: 30px;
  border-radius: 15px;
  display: inline-block;
  color: #fff;
  text-align: center;
  line-height: 30px;
}
.appointment-card-head {
  min-height: 80px;
  position: relative;
}
.appointment-card .patient-name {
  display: block;
  margin-top: 10px;
  width: 75%;
}
.appointment-card .patient-name img {
  height: 20px;
  margin-right: 5px;
}
.appointment-card .practitioner-name {
  display: block;
  margin-top: 12px;
  width: 75%;
}
.appointment-card .practitioner-name img {
  height: 20px;
  margin-right: 5px;
}
.appointment-card .appointment-id {
  padding: 3px 5px;
  color: #45bd5b;
  text-transform: uppercase;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  font-weight: normal;
  box-shadow: none;
  font-size: 12px;
  background: #fff;
  margin-top: 3px;
}
.appointment-card .appointment-time {
  font-size: 11px;
  border-radius: 5px;
  padding: 3px 5px;
  border: 1px solid #eaeaea;
  background: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.appointment-card .appointment-type {
  padding: 3px 5px;
  color: #0fa0cf;
  text-transform: uppercase;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  font-weight: normal;
  box-shadow: none;
  font-size: 12px;
  background: #fff;
  margin-left: 5px;
  margin-top: 3px;
}
.appointment-card .appointment-date {
  color: #6c757d;
  font-weight: normal;
  box-shadow: none;
  font-size: 12px;
  text-align: right;
}

.appointment-card .expiry-time {
  color: #f14c62;
}
.appointment-card .expiry-appointment-time {
  font-size: 11px;
  border-radius: 5px;
  padding: 3px 5px;
  border: 1px solid #f14c62;
  background: #f14c62;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  color: #fff;
}

.patient-mobile,
.patient-email {
  display: block;
  font-size: 12px;
}
.patient-email svg,
.patient-mobile svg {
  color: #0fa0cf;
}
.empty-nodata {
  margin: 50% 0;
  width: 100%;
  margin-bottom: 0px;
}
.card-header-count {
  position: absolute;
  right: 15px;
  font-size: 12px;
  background: #eef2f3;
  color: #222;
  height: 20px;
  text-align: center;
  border: 1px solid #e3e3e3;
  font-weight: 600;
  line-height: 20px;
  width: 25px;
  border-radius: 10px;
}
.appointment-card .appointment-procedure_name {
  padding: 3px 5px;
  color: #0fa0cf;
  text-transform: uppercase;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  font-weight: normal;
  box-shadow: none;
  font-size: 12px;
  background: #fff;
  margin-top: 3px;
}

.practitioners-list .ant-list-item,
.patients-list .ant-list-item {
  width: 33.333%;
  padding: 0px;
  display: inline-block;
}
.practitioners-list .ant-list-item .practitioner-list-card,
.patients-list .ant-list-item .patient-list-card {
  width: 100%;
  padding: 15px;
  cursor: pointer;
}
.practitioner-list-card .card {
  min-height: 90px;
  margin: 0px;
}
.patient-list-card .card {
  margin: 0px;
}
.practitioner-list-card .card:hover,
.patient-list-card .card:hover {
  box-shadow: 0 6px 10px -4px #0fa0cf52;
  transition: box-shadow 0.3s ease-in-out;
}
.practitioner-list-card .profile-image {
  width: 70px;
  height: 70px;
  display: inline-block;
  margin-top: -30px;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  box-shadow: 1px 1px 4px #0000001a;
}
.patient-list-card .profile-image {
  width: 70px;
  height: 70px;
  display: inline-block;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  box-shadow: 1px 1px 4px #0000001a;
}

.practitioner-list-card .info-container,
.patient-list-card .info-container {
  display: inline-block;
  padding: 10px;
  padding-top: 0px;
  vertical-align: top;
  width: 75%;
}

.practitioner-list-card .info-container h4,
.patient-list-card .info-container h4 {
  font-size: 16px;
  line-height: 16px;
  margin: 0px;
  font-weight: 500;
}

.practitioner-list-card .info-container p.department,
.patient-list-card .info-container p.email,
.patient-list-card .info-container p.mobile {
  margin-top: 3px;
  color: #0fa0cf;
  margin-bottom: 0px;
  font-size: 12px;
}

.practitioner-list-card .info-container p.department .anticon,
.patient-list-card .info-container p.email .anticon,
.patient-list-card .info-container p.mobile .anticon {
  vertical-align: middle;
  margin-right: 3px;
}
.practitioner-list-card p.job-title {
  margin-bottom: 0px;
  color: grey;
  margin-top: 7px;
  font-size: 12px;
}

.practitioner-list-card p.job-title .anticon {
  margin-right: 3px;
  vertical-align: text-top;
}

.practitioner-list-card .LinesEllipsis,
.patient-list-card .LinesEllipsis {
  display: contents;
}
.remove-button {
  position: absolute;
  bottom: 0px;
  margin: 0px;
  height: 25px;
  right: 0px;
  line-height: 13px;
  width: 25px;
  background: transparent;
  padding: 0px;
  border: 1px solid red;
}
.remove-button:hover,
.remove-button:active,
.remove-button:focus,
.remove-button:focus-within {
  color: #fff !important;
  background-color: red !important;
  border: 1px solid red !important;
}
.remove-button .anticon {
  color: red !important;
}

.remove-button:hover .anticon,
.remove-button:active .anticon,
.remove-button:focus .anticon,
.remove-button:focus-within .anticon {
  color: #fff !important;
}

.ant-list-pagination {
  padding: 0px 15px;
}
.ant-pagination-item-link,
.ant-pagination-item {
  border-radius: 5px !important;
}
.char-avatar {
  height: 70px;
  width: 70px;
  background: #45bd5b;
  border-radius: 10px;
  position: relative;
}
.char-avatar span {
  color: #fff;
  font-size: 34px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-search {
  position: absolute;
  right: 15px;
  width: 30%;
  margin-right: 10px;
  height: 40px;
  border: none;
  box-shadow: none;
  z-index: 2;
}
.anticon-search svg {
  color: grey;
}
.card-search.ant-input:focus,
.card-search.ant-input-focused {
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
}
.appointments-page-header .col-12 {
  margin-bottom: 10px;
}
.appointments-page.patient .appointment-card {
  background: #f6f8f9 !important;
}
button.pending-request-status {
  position: absolute;
  bottom: 0px;
  right: 0px;
  line-height: 12px;
  font-size: 12px;
  padding: 3px 7px;
  height: auto;
  background: orange;
  color: #fff;
  border: none;
  z-index: 2;
}
button.pending-request-status:hover,
button.pending-request-status:focus {
  background: rgb(218, 142, 1);
  color: #fff;
}
.incoming-request-buttons {
  position: absolute;
  right: 0;
  bottom: 0;
  gap: 3px;
  display: flex;
}
.incoming-request-buttons button {
  padding: 3px 7px;
  font-size: 12px;
  height: auto;
  line-height: 12px;
  z-index: 2;
}
.ant-btn-danger:hover,
.ant-btn-danger:focus {
  color: #fff !important;
  background: #f0504e !important;
  border-color: #f0504e !important;
}
button.send-request {
  position: absolute;
  right: 0px;
  bottom: 0px;
  height: auto;
  background: #eef2f3;
  line-height: 12px;
  padding: 3px 7px;
  border-color: #eaeaea;
  color: #222;
  font-size: 12px;
}
.card-list-header {
  display: flex;
}
.card-list-header p {
  margin-top: 7px;
}
.patient-info-row .row {
  padding: 3px;
  background: #f5f8f9;
  margin: 1px 0px;
  border-radius: 5px;
}
.patient-info-row .ant-typography strong {
  color: #959595;
  font-weight: normal;
}

.appointments-page ul.ant-list-items {
  display: flex;
  flex-wrap: wrap;
}
.appointments-page ul.ant-list-items li.ant-list-item {
  flex: 0 0 33.33%;
  border: none;
  padding: 10px;
}
.appointments-page ul.ant-list-items li.ant-list-item .appointment-card {
  margin-bottom: 5px;
  border-radius: 7px;
  width: 100%;
  position: relative;
  font-size: 14px;
  background: #fff;
  padding: 10px;
  border: 1px solid #eaeaea;
  cursor: pointer;
}
.appointment-card-right {
  display: flex;
  align-items: self-end;
  flex-direction: column;
  position: absolute;
  right: 0px;
  top: 0px;
  gap: 10px;
}
.appointment-card-right span {
}
.appointment-action-buttons button.approve {
  background: #48b176;
  color: #fff;
  border: #48b176;
}
.appointment-action-buttons button.cancel {
  background: #ec4f62;
  color: #fff;
  border: #ec4f62;
}
.appointment-action-buttons button.reschedule {
  background: #f3a400;
  color: #fff;
  border: #f3a400;
}
.review-card {
  margin-bottom: 5px;
  border-radius: 7px;
  width: 100%;
  height:250px;
  position: relative;
  font-size: 14px;
  background: #fff;
  padding: 10px;
  border: 1px solid #eaeaea;
  cursor: pointer;
  overflow:auto;
  display: flex;
  flex-direction: column;
}

.review-card-header {
  min-height: 80px;
  position: relative;
  width: 100%;
}

.review-id {
  padding: 3px 5px;
  color: #45bd5b;
  text-transform: uppercase;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  font-weight: normal;
  box-shadow: none;
  font-size: 12px;
  background: #fff;
  margin-top: 3px;
}

.appointment-action-buttons button.checkin {
  background: #0fa0cf;
  color: #fff;
  border: #0fa0cf;
}
.appointment-action-buttons button.videoconference{
  background: #48b176;
  color: #fff;
  border:#48b176;
}

.appointment-action-buttons button.checkout {
  background: #48bbb2;
  color: #fff;
  border: #48bbb2;
}

.appointment-action-buttons button.reports {
  background: #ed9b20;
  color: #fff;
  border: #ed9b20;
}
.appointment-action-buttons button:hover{
  font-style: italic;
  border:none;
  box-shadow: 2px 5px 5px 1px #575457;
}
.appointment-action-buttons button:active{
  transform: scale(0.8);  
  border: 1px solid black;
}

.procedures-page .ant-list-items {
  display: flex;
  flex-wrap: wrap;
}

.procedures-page .ant-list-item {
  flex: 0 0 25%;
  border: none;
  padding: 10px;
}
.procedures-page .procedure-card {
  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);
  background: #f5f8f9;
  border-radius: 10px;
}
.procedures-page .procedure-card-image-container {
  position: relative;
}

/* add  fading gradient to bottom of car dimage img */
.procedures-page .procedure-card-image-container:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

.procedures-page .procedure-card-image-container img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  min-height: 200px;
  min-width: 220px;
  width: 220px;
  object-fit: cover;
}
.procedures-page {
}

@media only screen and (max-width: 768px) {
  .procedures-page .procedure-card-image-container img {
    /* min-width: 85vw; */
  }
  .procedures-page .ant-list-items {
    justify-content: center;
  }
}

.procedures-page .procedure-title {
  position: absolute;
  bottom: 0px;
  font-size: 13px;
  padding: 5px 0px;
  width: 100%;
  background: #eef2f3;
  border: 3px solid #fff;
  border-radius: 0px;
  padding-left: 10px;
  color: #222;
  text-transform: capitalize;
}
.procedures-page .procedure-title p {
  margin-bottom: 0px;
}
.procedures-page .procedure-card-actions {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.procedures-page .procedure-card-actions button {
}
.notifications-tab .ant-tabs-nav {
  margin-bottom: 0px;
}
.multiple-image-selector {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fit, 104px);
  grid-gap: 10px;
  gap: 10px;
}

.multiple-image-selector img {
  padding: 8px;
  width: 104px;
  height: 104px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.multiple-image-selector .image-poper {
  line-height: 10px;
  position: absolute;
  top: 5px;
  right: 12px;
  border: 1px solid #8b8b8b;
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 10px;
  height: auto;
}

.multiple-image-selector .image-poper:hover {
  background: #fff;
  border: 1px solid #0fa0cf;
}
/* .image-poper {
  line-height: 10px;
  position: absolute;
  right: 5px;
  top: 5px;
  border: 1px solid #8b8b8b;
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 10px;
  height: auto;
} */
.notification-card {
  border: 1px solid #eaeaea;
  background: #f3fdff;
  background: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  cursor: pointer;
}
.notification-card.unread {
  background: #f3fdff;
}
.notification-card .read-icon img {
  height: 24px;
}
.notification-card .id span {
  border: 1px solid #c3f0ff;
  border-radius: 3px;
  padding: 3px 10px;
  color: #0fa0cf;
  background: #f7fdff;
}
.notification-card .type span {
  text-transform: capitalize;
  border: 1px solid;
  padding: 3px 10px;
  border-color: #eef2f3;
  border-radius: 5px;
  background: #eef2f3;
}

.notification-card:hover {
  border-color: #7cdfff;
}
.navbar-notifications .ant-card-head-title {
  padding: 10px;
}
.report-add-row {
  background: #f4f5f7;
  margin: 0px;
  border-radius: 10px;
  padding: 15px;
  padding-bottom: 0px;
  margin-bottom: 10px;
}
.report-add-container {
  padding: 10px;
}
.report-add-container label::before{
  content:"*";
  color:red;
  margin-right:0.2rem;
}
.primaryButtonRadio
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #0fa0cf;
  border-color: #0fa0cf;
}
@media (max-width: 1350px) {
  .appointments-page ul.ant-list-items li.ant-list-item {
    flex: 0 0 50%;
  }
  .card-stats .card-body .numbers .card-category,
  .card-footer .ant-btn-round {
    font-size: 13px;
  }
}
@media (max-width: 991px) {
  .notification-card .ant-row {
    gap: 10px !important;
    row-gap: 10px !important;
  }
  .procedures-page .ant-list-item {
    flex: 0 0 25%;
  }

  .appointment-type,
  .appointment-time,
  .appointment-id {
    font-size: 14px;
  }
  .practitioners-list .ant-list-item,
  .patients-list .ant-list-item {
    width: 50%;
  }
  .card-search {
    width: 300px;
    box-shadow: none;
    margin-top: 12px;
    height: 36px;
  }
  .card-list-header.patient .card-search {
    margin-top: 0px;
  }
  .appointments-page ul.ant-list-items li.ant-list-item {
    flex: 0 0 50%;
  }
}

@media (max-width: 767px) {
  .procedures-page .ant-list-item {
    flex: 0 0 50%;
  }
  .general-info .details-wraper {
    display: block;
  }
  .appointments-page ul.ant-list-items li.ant-list-item {
    flex: 0 0 100%;
  }
  .practitioners-list .ant-list-item,
  .patients-list .ant-list-item {
    width: 100%;
  }
  .practitioners-list .ant-list-item .practitioner-list-card {
    padding: 0px;
    padding-bottom: 20px;
    margin-top: 20px;
  }
  .patients-list .ant-list-item .patient-list-card {
    padding: 0px;
    padding-bottom: 10px;
    margin-top: 10px;
  }
  .practitioner-list-card .card,
  .patient-list-card .card {
    min-height: auto;
  }
  .card-search {
    width: 100%;
    right: 0px;
    box-shadow: none;
    height: 36px;
    position: relative;
  }
  .card-list-header.patient {
    display: block;
  }
  .card-list-header.patient p {
    margin-bottom: 10px;
    text-align: center;
  }
}

.ant-table {
  display: block;
}

@media screen and (max-width: 600px) {
  .ant-picker-panel-container .ant-picker-panels {
    flex-direction: column;
  }
  .ant-picker-range-wrapper {
    justify-content: center;
  }
  .ant-table-thead {
    display: none;
  }
  .ant-table-thead > tr th:first-of-type,
  .ant-table-tbody > tr th:first-of-type,
  .ant-table-thead > tr td:first-of-type,
  .ant-table-tbody > tr td:first-of-type {
    padding-top: 1rem;
  }
  .ant-table-thead > tr th:last-of-type,
  .ant-table-tbody > tr th:last-of-type,
  .ant-table-thead > tr td:last-of-type,
  .ant-table-tbody > tr td:last-of-type {
    padding-bottom: 1rem;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > th,
  .ant-table-thead > tr > td,
  .ant-table-tbody > tr > td {
    display: block;
    width: auto !important;
    border: none;
    padding: 0 1rem;
    font-size: 1.1rem;
  }
  .ant-table-tbody > tr > td::before {
    content: attr(data-label) " :";
    float: left;
    font-weight: bold;
    text-transform: capitalize;
    margin-right: 15px;
  }
  .ant-table-thead > tr > th:last-child,
  .ant-table-tbody > tr > th:last-child,
  .ant-table-thead > tr > td:last-child,
  .ant-table-tbody > tr > td:last-child {
    border-bottom: 1px solid #eee;
  }
}

.section-label {
  font-size: 1rem;
  color: #131313;
  text-align: left;
  margin: 0;
}

.card-body-hospitals {
  display: grid;
  grid-template-columns: 70px 1fr;
}

.antd-message {
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-gap: 7px;
  width: 350px;
}
.antd-message .icon {
  width: 16px;
  height: 16px;
}
.antd-message .body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.antd-message .message-heading {
  font-size: 14px;
  font-weight: 500;
  color: #1b1b1b;
}
.antd-message .message-body {
  font-size: 12px;
  color: #242424;
  text-align: left;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.subscription-window {
  background: #fff;
  border-radius: 5px;
  padding: 15px;
  border: 2px dashed #eaeaea;
}
.subscription-status {
  font-weight: 600;
  font-size: 16px;
}
.subscription-content {
  text-align: center;
  padding: 30px;
}
.subscription-content h5 {
  color: #959595;
}
.subscription-content p {
  margin-bottom: 0px;
}
.subscription-window-footer {
  text-align: center;
}
.subscription-window-footer p {
  margin-bottom: 0px;
}
.subscription-window-footer a {
  color: #0fa0cf;
}
.subscription-window-header {
  display: flex;
  justify-content: space-between;
}
.subscription-count-items {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.subscription-count-item {
  display: flex;
  padding: 3px 10px;
  border-radius: 3px;
}
.subcription-count-label {
  font-weight: 600;
  min-width: 230px;
}
.subcription-count-value {
  margin-right: 10px;
  font-weight: 600;
}
.form-parallel-display {
  background: #f1f4f7;
  border-radius: 5px;
  padding: 10px;
  margin-left: 15px;
  margin-top: 28px;
}

.subscription-activation label {
  margin-bottom: 7px;
}
.subscription-activation .form-parallel-display label {
  margin-bottom: 0px;
}
.subscription-activate-total {
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  background: #eef8ee;
  padding: 10px;
  border-radius: 5px;
  border: 1px dashed #45bd5b;
}
.subscription-activate-summary-content {
  width: 50%;
  margin: 0 auto;
  margin-bottom: 15px;
}
.subscription-activate-summary-content .ant-row {
  justify-content: space-between;
  background: #f4f5f7;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-radius: 5px;
}
.total-amount.ant-row {
  padding: 10px;
  background: #eef8ee;
  font-weight: 700;
}
.apply-coupon-button {
  margin-top: 28px;
  margin-left: 15px;
  height: 38px;
}
.coupon-error {
  font-size: 12px;
  color: red;
}
.subscription-modal .ant-modal-header {
  background: #021e33;
}
.subscription-modal .ant-modal-title,
.subscription-modal .ant-modal-close-x {
  color: #0fa0cf;
}
.billing-history {
  margin-top: 15px;
}
.billing-history h5 {
  font-size: 18px;
  font-weight: 500;
}
.subscription-payment-success {
  text-align: center;
  padding: 30px;
}
.subscription-payment-success .success-image {
  width: 100px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.subscription-payment-success .success-text {
  font-size: 16px;
}
.upgrade-card {
  background: #f5f8f9;
  padding: 15px 0px;
  margin-bottom: 10px;
}
@media screen and (min-width: 767px) {
  .md-mt-35 {
    margin-top: 35px;
  }
 
}
@media screen and (max-width: 991px) {
  .subscription-count-items {
    flex-direction: column;
  }
}
@media screen and (max-width: 767px) {
  .slot-remove-btn{
    margin-bottom: 30px;
    display: block!important;
    text-align: center;
  }
  .subscription-content h5 {
    font-weight: 600;
    font-size: 14px;
  }
  .subscription-content p {
    font-size: 12px;
  }
  .subscription-billing-history .ant-table-tbody > tr > td::before {
    display: none;
  }
  .subscription-billing-history .ant-table-cell {
    margin-bottom: 10px;
  }
  .subscription-activation .ant-row {
    flex-flow: column;
  }
  .subscription-activation .form-parallel-display,
  .subscription-activation .apply-coupon-button {
    margin-left: 0px;
  }
  .subscription-activation .subscription-activate-summary-content {
    width: 100%;
  }
  .subscription-activation .ant-btn-secondary {
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC;;;;;cAKY;AACd;AACA;;;;;;;;;;GAUG;AACH;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;;;;EAIE,cAAc;EACd,eAAe;AACjB;AACA;;;;EAIE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,iFAAiB;EAAjB,mBAAiB;EACjB,UAAc;EAAd,gBAAc;EACd,gBAAoB;EAApB,sBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;AACvB;AACA;;;;EAIE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;AACA;;EAEE,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;AACA;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;AACA;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;AACA;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;;;;;;;;;;GAWG;AACH;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;;;;IAIE,iBAAiB;EACnB;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;;;IAIE,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;;;;IAIE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;;AAEF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".sidebar:after,\n.off-canvas-sidebar:after {\n  background: #001628;\n}\n.sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n  display: none;\n}\n.sidebar-mini .sidebar .logo a.logo-mini,\n.off-canvas-sidebar .logo a.logo-mini {\n  display: block;\n}\n.logo-normal {\n  text-align: left;\n  margin-left: 15px;\n}\n.logo-normal img {\n  width: 150px;\n}\n.sidebar .logo:after,\n.off-canvas-sidebar .logo:after,\n.sidebar .user:after,\n.off-canvas-sidebar .user:after {\n  background-color: #0fa0cf30;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n  text-transform: capitalize;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n  font-weight: 500;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n  font-size: 14px;\n}\n.nav li a img {\n  width: 24px;\n  display: inline;\n}\n.sidebar .nav p,\n.off-canvas-sidebar .nav p {\n  display: inline;\n  margin-left: 15px;\n}\n.nav li a {\n  display: flex;\n}\n.sidebar-mini .sidebar .nav p,\n.off-canvas-sidebar .nav p {\n  /* display: none; */\n}\n.main-panel > .content {\n  padding: 0 15px 30px;\n  margin-top: 75px;\n}\n.data-table {\n  background: #fff;\n  padding: 15px;\n  border-radius: 15px;\n}\n.data-table h5 {\n  display: none;\n}\n.table-search-bar input {\n  color: #222;\n  background-color: #eef2f3;\n  border: 1px solid #eef2f3;\n}\n.table th,\n.table td {\n  border-top: 1px solid #eef2f3;\n}\n\n.react-bootstrap-table-pagination-total {\n  margin-left: 15px;\n}\n.pagination .page-item.active > .page-link,\n.pagination .page-item.active > .page-link:focus,\n.pagination .page-item.active > .page-link:hover {\n  background-color: #0fa0cf;\n  border-color: #0fa0cf;\n  color: #ffffff;\n}\n.table > thead > tr > th {\n  background: #0fa0cf17;\n  color: #0fa0cf;\n}\n.navbar.navbar-transparent {\n  border-bottom: none;\n}\n.table-avatar {\n  border-radius: 5px;\n  border: 1px solid;\n  border-color: #eef2f3;\n  height: 40px;\n  width: 40px;\n  overflow: hidden;\n  margin-right: 10px;\n  display: inline-block;\n}\n.table-avatar img {\n  max-width: 100%;\n  height: auto;\n}\n.table-avatar-name span {\n  display: inline-block;\n}\n.p-0 {\n  padding: 0px !important;\n}\n.max-width-100 {\n  max-width: 100%;\n}\n.full-width {\n  width: 100%;\n}\n.table-search-bar .form-control {\n  color: #222;\n  background-color: #eef2f3;\n  border: 1px solid #eef2f3;\n}\n.table td,\n.table th {\n  border-top: 1px solid #f0f2f5;\n  vertical-align: middle;\n}\n.table td p {\n  margin-bottom: 0px !important;\n}\n.ant-dropdown-button button {\n  background: #f0f2f5;\n  border: none;\n}\n.ant-dropdown-button button:hover,\n.ant-dropdown-button button:focus,\n.ant-dropdown-button button:active {\n  background: #f0f2f5;\n  border: none;\n  color: #0fa0cf;\n}\n\n.total-spinner {\n  position: fixed;\n  z-index: 999;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.total-spinner-backdrop {\n  z-index: 99;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #ffffff99;\n}\n.ant-spin-dot-item {\n  background: #0fa0cf;\n}\n.react-bootstrap-table .anticon-eye svg {\n  color: #0fa0cf;\n  font-size: 16px;\n  cursor: pointer;\n}\n.view-name {\n  cursor: pointer;\n}\n.view-name:hover {\n  color: #0fa0cf;\n}\n.data-table .table thead th {\n  border-bottom: none;\n}\n.data-table .table th {\n  border-top: none;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.react-bootstrap-table-pagination-total {\n  margin-left: 15px;\n}\n.react-bootstrap-table {\n  max-width: 100%;\n  overflow: scroll;\n}\n.fa.fa-star.filled {\n  color: #0fa0cf;\n}\n.btn,\n.navbar .navbar-nav > a.btn {\n  background: #00000020;\n}\n.card-stats .icon-big {\n  height: 30px;\n  width: 50px;\n  min-height: 50px;\n  font-size: 0px;\n}\n.navbar.navbar-transparent {\n  background: #fff !important;\n}\n.react-loading-skeleton {\n  background-color: #f7f7f7 !important;\n  background-image: linear-gradient(\n    90deg,\n    #fbfbfb,\n    #fbfbfb,\n    #fbfbfb\n  ) !important;\n}\n/* .ant-tabs-tab.ant-tabs-tab-active {\n  background: #0fa0cf;\n  padding: 12px 16px;\n  border-radius: 5px;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff;\n}\n.ant-tabs-tab:hover {\n  color: #0fa0cf;\n} */\n.card-component {\n  margin: 0px 10px 10px;\n  padding: 15px;\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n}\n.card-component:hover {\n  box-shadow: 0 6px 10px -4px #0fa0cf36;\n  /* background: #f7fdff; */\n}\n.avatar-holder {\n  height: 75px;\n  background-position: center;\n  width: 100%;\n  background-size: cover;\n  padding: 2px;\n  position: relative;\n  border: 1px solid #eaeaea;\n  border-radius: 10px;\n}\n.card-row {\n  margin: 10px 0px;\n}\n.text-holder {\n  padding: 0px 10px;\n}\n.text-holder h6 {\n  margin: 0px;\n  font-size: 16px;\n  font-weight: normal;\n  text-transform: capitalize;\n}\n.location-text,\n.gender-text,\n.dob-text,\n.date-text {\n  color: #7d7d7d;\n  font-size: 12px;\n}\n.location-text svg,\n.gender-text svg,\n.dob-text svg,\n.date-text svg {\n  color: #45bd5b;\n}\n.status-text {\n  margin-top: 7px;\n  margin-bottom: 0px;\n}\n.card-component .alpha-dummy-avatar {\n  height: 100%;\n  background: #bee2c0;\n  width: 100%;\n  text-shadow: 1px 1px 4px #33894d47;\n}\n.card-component .alpha-dummy-avatar p {\n  font-size: 32px;\n  margin-bottom: 0px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.card-component .ant-btn-group.ant-dropdown-button button:first-child {\n  display: none;\n}\n.card-component .ant-btn-group.ant-dropdown-button {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n}\n.card-component\n  .ant-btn.ant-btn-default.ant-btn-icon-only.ant-dropdown-trigger {\n  height: 22px;\n  line-height: 12px;\n}\n.item-details-modal .patient .profile-image {\n  margin-top: 0px;\n}\n.item-details-modal .patient .profile-info {\n  margin-top: 20px;\n}\n.appointment-details .ant-modal-body {\n  padding-top: 0px;\n}\n\n.ant-tabs-ink-bar {\n  background: #0fa0cf;\n}\n.appointment-details .ant-modal-footer {\n  display: none;\n}\n.modal-row .modal-column:nth-child(even) {\n  background: #eaf5fa;\n}\n.modal-row {\n  border: 1px solid #eaf5fa;\n}\n.modal-row .modal-column {\n  padding: 5px;\n}\n\n.report-list {\n  color: #0fa0cf;\n  /* list-style: none; */\n  /* padding-left: 10px; */\n}\n.report-list a {\n  color: #0fa0cf;\n}\n.appointment-details .ant-tabs-tab.ant-tabs-tab-active {\n  background: unset;\n  padding: unset;\n  border-radius: unset;\n}\n.hospitals-tab .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff;\n}\n.hospitals-tab .ant-tabs-ink-bar {\n  background: transparent;\n}\n.list-count {\n  margin-bottom: 0px;\n  margin-left: 10px;\n}\n.paginator {\n  position: relative;\n  text-align: right;\n}\n.paginator .previous,\n.paginator .next {\n  color: #0fa0cf;\n  display: inline-block;\n  height: 25px;\n  width: 25px;\n  border-radius: 5px;\n  text-align: center;\n  background: transparent;\n  border: 1px solid #0fa0cf;\n  cursor: pointer;\n  margin-right: 10px;\n}\n.paginator .previous:hover,\n.paginator .next:hover {\n  background: #0fa0cf;\n  color: #fff;\n}\n.paginator .previous.disabled,\n.paginator .next.disabled {\n  background: #dfdfdf;\n  color: #b1afaf;\n  border-color: #b1afaf;\n}\n.alpha-dummy-avatar,\n.table-avatar {\n  cursor: pointer;\n}\n.appointments-container {\n  display: flex;\n  flex-direction: column;\n}\n.sidebar .nav li > a,\n.off-canvas-sidebar .nav li > a {\n  opacity: 1;\n}\n.sidebar .nav li.active {\n  background: #0fa0cf0f;\n}\n.today-appointments {\n  height: 385px;\n  max-height: 385px;\n  overflow: scroll;\n}\n.today-appointments.lab {\n  height: 4355px;\n  max-height: 435px;\n}\n.today-appointments .appointment-card {\n  margin-bottom: 5px;\n  border-radius: 7px;\n  width: 100%;\n  position: relative;\n  font-size: 12px;\n  background: #f6f8f9;\n  padding: 10px;\n  border: 1px solid #eaeaea;\n  cursor: pointer;\n}\n.today-appointments .appointment-card.lab {\n  font-size: 14px;\n}\n.today-appointments .appointment-card:hover {\n  box-shadow: 0px 1px 4px rgb(0 0 0 / 15%);\n  transition: box-shadow 0.3s ease-in-out;\n}\n.appointment-card .appointment-card-header {\n  width: 100%;\n}\n.appointment-card .appointment-action-buttons {\n  padding: 10px 0px 0px;\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n.appointment-card .appointment-action-buttons button {\n  /* padding: 3px 0px; */\n  flex: auto;\n  height: auto;\n}\n.appointment-card .patient-avatar {\n  height: 30px;\n  background: #0fa0cf;\n  width: 30px;\n  border-radius: 15px;\n  display: inline-block;\n  color: #fff;\n  text-align: center;\n  line-height: 30px;\n}\n.appointment-card-head {\n  min-height: 80px;\n  position: relative;\n}\n.appointment-card .patient-name {\n  display: block;\n  margin-top: 10px;\n  width: 75%;\n}\n.appointment-card .patient-name img {\n  height: 20px;\n  margin-right: 5px;\n}\n.appointment-card .practitioner-name {\n  display: block;\n  margin-top: 12px;\n  width: 75%;\n}\n.appointment-card .practitioner-name img {\n  height: 20px;\n  margin-right: 5px;\n}\n.appointment-card .appointment-id {\n  padding: 3px 5px;\n  color: #45bd5b;\n  text-transform: uppercase;\n  border: 1px solid #eaeaea;\n  border-radius: 3px;\n  font-weight: normal;\n  box-shadow: none;\n  font-size: 12px;\n  background: #fff;\n  margin-top: 3px;\n}\n.appointment-card .appointment-time {\n  font-size: 11px;\n  border-radius: 5px;\n  padding: 3px 5px;\n  border: 1px solid #eaeaea;\n  background: #fff;\n  width: fit-content;\n}\n.appointment-card .appointment-type {\n  padding: 3px 5px;\n  color: #0fa0cf;\n  text-transform: uppercase;\n  border: 1px solid #eaeaea;\n  border-radius: 3px;\n  font-weight: normal;\n  box-shadow: none;\n  font-size: 12px;\n  background: #fff;\n  margin-left: 5px;\n  margin-top: 3px;\n}\n.appointment-card .appointment-date {\n  color: #6c757d;\n  font-weight: normal;\n  box-shadow: none;\n  font-size: 12px;\n  text-align: right;\n}\n\n.appointment-card .expiry-time {\n  color: #f14c62;\n}\n.appointment-card .expiry-appointment-time {\n  font-size: 11px;\n  border-radius: 5px;\n  padding: 3px 5px;\n  border: 1px solid #f14c62;\n  background: #f14c62;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  color: #fff;\n}\n\n.patient-mobile,\n.patient-email {\n  display: block;\n  font-size: 12px;\n}\n.patient-email svg,\n.patient-mobile svg {\n  color: #0fa0cf;\n}\n.empty-nodata {\n  margin: 50% 0;\n  width: 100%;\n  margin-bottom: 0px;\n}\n.card-header-count {\n  position: absolute;\n  right: 15px;\n  font-size: 12px;\n  background: #eef2f3;\n  color: #222;\n  height: 20px;\n  text-align: center;\n  border: 1px solid #e3e3e3;\n  font-weight: 600;\n  line-height: 20px;\n  width: 25px;\n  border-radius: 10px;\n}\n.appointment-card .appointment-procedure_name {\n  padding: 3px 5px;\n  color: #0fa0cf;\n  text-transform: uppercase;\n  border: 1px solid #eaeaea;\n  border-radius: 3px;\n  font-weight: normal;\n  box-shadow: none;\n  font-size: 12px;\n  background: #fff;\n  margin-top: 3px;\n}\n\n.practitioners-list .ant-list-item,\n.patients-list .ant-list-item {\n  width: 33.333%;\n  padding: 0px;\n  display: inline-block;\n}\n.practitioners-list .ant-list-item .practitioner-list-card,\n.patients-list .ant-list-item .patient-list-card {\n  width: 100%;\n  padding: 15px;\n  cursor: pointer;\n}\n.practitioner-list-card .card {\n  min-height: 90px;\n  margin: 0px;\n}\n.patient-list-card .card {\n  margin: 0px;\n}\n.practitioner-list-card .card:hover,\n.patient-list-card .card:hover {\n  box-shadow: 0 6px 10px -4px #0fa0cf52;\n  transition: box-shadow 0.3s ease-in-out;\n}\n.practitioner-list-card .profile-image {\n  width: 70px;\n  height: 70px;\n  display: inline-block;\n  margin-top: -30px;\n  border-radius: 10px;\n  background-size: cover;\n  background-position: center;\n  box-shadow: 1px 1px 4px #0000001a;\n}\n.patient-list-card .profile-image {\n  width: 70px;\n  height: 70px;\n  display: inline-block;\n  border-radius: 10px;\n  background-size: cover;\n  background-position: center;\n  box-shadow: 1px 1px 4px #0000001a;\n}\n\n.practitioner-list-card .info-container,\n.patient-list-card .info-container {\n  display: inline-block;\n  padding: 10px;\n  padding-top: 0px;\n  vertical-align: top;\n  width: 75%;\n}\n\n.practitioner-list-card .info-container h4,\n.patient-list-card .info-container h4 {\n  font-size: 16px;\n  line-height: 16px;\n  margin: 0px;\n  font-weight: 500;\n}\n\n.practitioner-list-card .info-container p.department,\n.patient-list-card .info-container p.email,\n.patient-list-card .info-container p.mobile {\n  margin-top: 3px;\n  color: #0fa0cf;\n  margin-bottom: 0px;\n  font-size: 12px;\n}\n\n.practitioner-list-card .info-container p.department .anticon,\n.patient-list-card .info-container p.email .anticon,\n.patient-list-card .info-container p.mobile .anticon {\n  vertical-align: middle;\n  margin-right: 3px;\n}\n.practitioner-list-card p.job-title {\n  margin-bottom: 0px;\n  color: grey;\n  margin-top: 7px;\n  font-size: 12px;\n}\n\n.practitioner-list-card p.job-title .anticon {\n  margin-right: 3px;\n  vertical-align: text-top;\n}\n\n.practitioner-list-card .LinesEllipsis,\n.patient-list-card .LinesEllipsis {\n  display: contents;\n}\n.remove-button {\n  position: absolute;\n  bottom: 0px;\n  margin: 0px;\n  height: 25px;\n  right: 0px;\n  line-height: 13px;\n  width: 25px;\n  background: transparent;\n  padding: 0px;\n  border: 1px solid red;\n}\n.remove-button:hover,\n.remove-button:active,\n.remove-button:focus,\n.remove-button:focus-within {\n  color: #fff !important;\n  background-color: red !important;\n  border: 1px solid red !important;\n}\n.remove-button .anticon {\n  color: red !important;\n}\n\n.remove-button:hover .anticon,\n.remove-button:active .anticon,\n.remove-button:focus .anticon,\n.remove-button:focus-within .anticon {\n  color: #fff !important;\n}\n\n.ant-list-pagination {\n  padding: 0px 15px;\n}\n.ant-pagination-item-link,\n.ant-pagination-item {\n  border-radius: 5px !important;\n}\n.char-avatar {\n  height: 70px;\n  width: 70px;\n  background: #45bd5b;\n  border-radius: 10px;\n  position: relative;\n}\n.char-avatar span {\n  color: #fff;\n  font-size: 34px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.card-search {\n  position: absolute;\n  right: 15px;\n  width: 30%;\n  margin-right: 10px;\n  height: 40px;\n  border: none;\n  box-shadow: none;\n  z-index: 2;\n}\n.anticon-search svg {\n  color: grey;\n}\n.card-search.ant-input:focus,\n.card-search.ant-input-focused {\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n}\n.appointments-page-header .col-12 {\n  margin-bottom: 10px;\n}\n.appointments-page.patient .appointment-card {\n  background: #f6f8f9 !important;\n}\nbutton.pending-request-status {\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  line-height: 12px;\n  font-size: 12px;\n  padding: 3px 7px;\n  height: auto;\n  background: orange;\n  color: #fff;\n  border: none;\n  z-index: 2;\n}\nbutton.pending-request-status:hover,\nbutton.pending-request-status:focus {\n  background: rgb(218, 142, 1);\n  color: #fff;\n}\n.incoming-request-buttons {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  gap: 3px;\n  display: flex;\n}\n.incoming-request-buttons button {\n  padding: 3px 7px;\n  font-size: 12px;\n  height: auto;\n  line-height: 12px;\n  z-index: 2;\n}\n.ant-btn-danger:hover,\n.ant-btn-danger:focus {\n  color: #fff !important;\n  background: #f0504e !important;\n  border-color: #f0504e !important;\n}\nbutton.send-request {\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  height: auto;\n  background: #eef2f3;\n  line-height: 12px;\n  padding: 3px 7px;\n  border-color: #eaeaea;\n  color: #222;\n  font-size: 12px;\n}\n.card-list-header {\n  display: flex;\n}\n.card-list-header p {\n  margin-top: 7px;\n}\n.patient-info-row .row {\n  padding: 3px;\n  background: #f5f8f9;\n  margin: 1px 0px;\n  border-radius: 5px;\n}\n.patient-info-row .ant-typography strong {\n  color: #959595;\n  font-weight: normal;\n}\n\n.appointments-page ul.ant-list-items {\n  display: flex;\n  flex-wrap: wrap;\n}\n.appointments-page ul.ant-list-items li.ant-list-item {\n  flex: 0 0 33.33%;\n  border: none;\n  padding: 10px;\n}\n.appointments-page ul.ant-list-items li.ant-list-item .appointment-card {\n  margin-bottom: 5px;\n  border-radius: 7px;\n  width: 100%;\n  position: relative;\n  font-size: 14px;\n  background: #fff;\n  padding: 10px;\n  border: 1px solid #eaeaea;\n  cursor: pointer;\n}\n.appointment-card-right {\n  display: flex;\n  align-items: self-end;\n  flex-direction: column;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  gap: 10px;\n}\n.appointment-card-right span {\n}\n.appointment-action-buttons button.approve {\n  background: #48b176;\n  color: #fff;\n  border: #48b176;\n}\n.appointment-action-buttons button.cancel {\n  background: #ec4f62;\n  color: #fff;\n  border: #ec4f62;\n}\n.appointment-action-buttons button.reschedule {\n  background: #f3a400;\n  color: #fff;\n  border: #f3a400;\n}\n.review-card {\n  margin-bottom: 5px;\n  border-radius: 7px;\n  width: 100%;\n  height:250px;\n  position: relative;\n  font-size: 14px;\n  background: #fff;\n  padding: 10px;\n  border: 1px solid #eaeaea;\n  cursor: pointer;\n  overflow:auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.review-card-header {\n  min-height: 80px;\n  position: relative;\n  width: 100%;\n}\n\n.review-id {\n  padding: 3px 5px;\n  color: #45bd5b;\n  text-transform: uppercase;\n  border: 1px solid #eaeaea;\n  border-radius: 3px;\n  font-weight: normal;\n  box-shadow: none;\n  font-size: 12px;\n  background: #fff;\n  margin-top: 3px;\n}\n\n.appointment-action-buttons button.checkin {\n  background: #0fa0cf;\n  color: #fff;\n  border: #0fa0cf;\n}\n.appointment-action-buttons button.videoconference{\n  background: #48b176;\n  color: #fff;\n  border:#48b176;\n}\n\n.appointment-action-buttons button.checkout {\n  background: #48bbb2;\n  color: #fff;\n  border: #48bbb2;\n}\n\n.appointment-action-buttons button.reports {\n  background: #ed9b20;\n  color: #fff;\n  border: #ed9b20;\n}\n.appointment-action-buttons button:hover{\n  font-style: italic;\n  border:none;\n  box-shadow: 2px 5px 5px 1px #575457;\n}\n.appointment-action-buttons button:active{\n  transform: scale(0.8);  \n  border: 1px solid black;\n}\n\n.procedures-page .ant-list-items {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.procedures-page .ant-list-item {\n  flex: 0 0 25%;\n  border: none;\n  padding: 10px;\n}\n.procedures-page .procedure-card {\n  box-shadow: 0 6px 10px -4px rgb(0 0 0 / 15%);\n  background: #f5f8f9;\n  border-radius: 10px;\n}\n.procedures-page .procedure-card-image-container {\n  position: relative;\n}\n\n/* add  fading gradient to bottom of car dimage img */\n.procedures-page .procedure-card-image-container:before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 70%;\n  background: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 1) 100%\n  );\n}\n\n.procedures-page .procedure-card-image-container img {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  min-height: 200px;\n  min-width: 220px;\n  width: 220px;\n  object-fit: cover;\n}\n.procedures-page {\n}\n\n@media only screen and (max-width: 768px) {\n  .procedures-page .procedure-card-image-container img {\n    /* min-width: 85vw; */\n  }\n  .procedures-page .ant-list-items {\n    justify-content: center;\n  }\n}\n\n.procedures-page .procedure-title {\n  position: absolute;\n  bottom: 0px;\n  font-size: 13px;\n  padding: 5px 0px;\n  width: 100%;\n  background: #eef2f3;\n  border: 3px solid #fff;\n  border-radius: 0px;\n  padding-left: 10px;\n  color: #222;\n  text-transform: capitalize;\n}\n.procedures-page .procedure-title p {\n  margin-bottom: 0px;\n}\n.procedures-page .procedure-card-actions {\n  padding: 5px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #fff;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n.procedures-page .procedure-card-actions button {\n}\n.notifications-tab .ant-tabs-nav {\n  margin-bottom: 0px;\n}\n.multiple-image-selector {\n  display: grid;\n  align-items: center;\n  grid-template-columns: repeat(auto-fit, 104px);\n  gap: 10px;\n}\n\n.multiple-image-selector img {\n  padding: 8px;\n  width: 104px;\n  height: 104px;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n}\n\n.multiple-image-selector .image-poper {\n  line-height: 10px;\n  position: absolute;\n  top: 5px;\n  right: 12px;\n  border: 1px solid #8b8b8b;\n  padding: 5px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 10px;\n  height: auto;\n}\n\n.multiple-image-selector .image-poper:hover {\n  background: #fff;\n  border: 1px solid #0fa0cf;\n}\n/* .image-poper {\n  line-height: 10px;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  border: 1px solid #8b8b8b;\n  padding: 5px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 10px;\n  height: auto;\n} */\n.notification-card {\n  border: 1px solid #eaeaea;\n  background: #f3fdff;\n  background: #fff;\n  padding: 15px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.notification-card.unread {\n  background: #f3fdff;\n}\n.notification-card .read-icon img {\n  height: 24px;\n}\n.notification-card .id span {\n  border: 1px solid #c3f0ff;\n  border-radius: 3px;\n  padding: 3px 10px;\n  color: #0fa0cf;\n  background: #f7fdff;\n}\n.notification-card .type span {\n  text-transform: capitalize;\n  border: 1px solid;\n  padding: 3px 10px;\n  border-color: #eef2f3;\n  border-radius: 5px;\n  background: #eef2f3;\n}\n\n.notification-card:hover {\n  border-color: #7cdfff;\n}\n.navbar-notifications .ant-card-head-title {\n  padding: 10px;\n}\n.report-add-row {\n  background: #f4f5f7;\n  margin: 0px;\n  border-radius: 10px;\n  padding: 15px;\n  padding-bottom: 0px;\n  margin-bottom: 10px;\n}\n.report-add-container {\n  padding: 10px;\n}\n.report-add-container label::before{\n  content:\"*\";\n  color:red;\n  margin-right:0.2rem;\n}\n.primaryButtonRadio\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: #fff;\n  background: #0fa0cf;\n  border-color: #0fa0cf;\n}\n@media (max-width: 1350px) {\n  .appointments-page ul.ant-list-items li.ant-list-item {\n    flex: 0 0 50%;\n  }\n  .card-stats .card-body .numbers .card-category,\n  .card-footer .ant-btn-round {\n    font-size: 13px;\n  }\n}\n@media (max-width: 991px) {\n  .notification-card .ant-row {\n    gap: 10px !important;\n    row-gap: 10px !important;\n  }\n  .procedures-page .ant-list-item {\n    flex: 0 0 25%;\n  }\n\n  .appointment-type,\n  .appointment-time,\n  .appointment-id {\n    font-size: 14px;\n  }\n  .practitioners-list .ant-list-item,\n  .patients-list .ant-list-item {\n    width: 50%;\n  }\n  .card-search {\n    width: 300px;\n    box-shadow: none;\n    margin-top: 12px;\n    height: 36px;\n  }\n  .card-list-header.patient .card-search {\n    margin-top: 0px;\n  }\n  .appointments-page ul.ant-list-items li.ant-list-item {\n    flex: 0 0 50%;\n  }\n}\n\n@media (max-width: 767px) {\n  .procedures-page .ant-list-item {\n    flex: 0 0 50%;\n  }\n  .general-info .details-wraper {\n    display: block;\n  }\n  .appointments-page ul.ant-list-items li.ant-list-item {\n    flex: 0 0 100%;\n  }\n  .practitioners-list .ant-list-item,\n  .patients-list .ant-list-item {\n    width: 100%;\n  }\n  .practitioners-list .ant-list-item .practitioner-list-card {\n    padding: 0px;\n    padding-bottom: 20px;\n    margin-top: 20px;\n  }\n  .patients-list .ant-list-item .patient-list-card {\n    padding: 0px;\n    padding-bottom: 10px;\n    margin-top: 10px;\n  }\n  .practitioner-list-card .card,\n  .patient-list-card .card {\n    min-height: auto;\n  }\n  .card-search {\n    width: 100%;\n    right: 0px;\n    box-shadow: none;\n    height: 36px;\n    position: relative;\n  }\n  .card-list-header.patient {\n    display: block;\n  }\n  .card-list-header.patient p {\n    margin-bottom: 10px;\n    text-align: center;\n  }\n}\n\n.ant-table {\n  display: block;\n}\n\n@media screen and (max-width: 600px) {\n  .ant-picker-panel-container .ant-picker-panels {\n    flex-direction: column;\n  }\n  .ant-picker-range-wrapper {\n    justify-content: center;\n  }\n  .ant-table-thead {\n    display: none;\n  }\n  .ant-table-thead > tr th:first-of-type,\n  .ant-table-tbody > tr th:first-of-type,\n  .ant-table-thead > tr td:first-of-type,\n  .ant-table-tbody > tr td:first-of-type {\n    padding-top: 1rem;\n  }\n  .ant-table-thead > tr th:last-of-type,\n  .ant-table-tbody > tr th:last-of-type,\n  .ant-table-thead > tr td:last-of-type,\n  .ant-table-tbody > tr td:last-of-type {\n    padding-bottom: 1rem;\n  }\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > th,\n  .ant-table-thead > tr > td,\n  .ant-table-tbody > tr > td {\n    display: block;\n    width: auto !important;\n    border: none;\n    padding: 0 1rem;\n    font-size: 1.1rem;\n  }\n  .ant-table-tbody > tr > td::before {\n    content: attr(data-label) \" :\";\n    float: left;\n    font-weight: bold;\n    text-transform: capitalize;\n    margin-right: 15px;\n  }\n  .ant-table-thead > tr > th:last-child,\n  .ant-table-tbody > tr > th:last-child,\n  .ant-table-thead > tr > td:last-child,\n  .ant-table-tbody > tr > td:last-child {\n    border-bottom: 1px solid #eee;\n  }\n}\n\n.section-label {\n  font-size: 1rem;\n  color: #131313;\n  text-align: left;\n  margin: 0;\n}\n\n.card-body-hospitals {\n  display: grid;\n  grid-template-columns: 70px 1fr;\n}\n\n.antd-message {\n  display: grid;\n  grid-template-columns: 16px 1fr;\n  grid-gap: 7px;\n  width: 350px;\n}\n.antd-message .icon {\n  width: 16px;\n  height: 16px;\n}\n.antd-message .body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.antd-message .message-heading {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1b1b1b;\n}\n.antd-message .message-body {\n  font-size: 12px;\n  color: #242424;\n  text-align: left;\n}\n.text-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.subscription-window {\n  background: #fff;\n  border-radius: 5px;\n  padding: 15px;\n  border: 2px dashed #eaeaea;\n}\n.subscription-status {\n  font-weight: 600;\n  font-size: 16px;\n}\n.subscription-content {\n  text-align: center;\n  padding: 30px;\n}\n.subscription-content h5 {\n  color: #959595;\n}\n.subscription-content p {\n  margin-bottom: 0px;\n}\n.subscription-window-footer {\n  text-align: center;\n}\n.subscription-window-footer p {\n  margin-bottom: 0px;\n}\n.subscription-window-footer a {\n  color: #0fa0cf;\n}\n.subscription-window-header {\n  display: flex;\n  justify-content: space-between;\n}\n.subscription-count-items {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n.subscription-count-item {\n  display: flex;\n  padding: 3px 10px;\n  border-radius: 3px;\n}\n.subcription-count-label {\n  font-weight: 600;\n  min-width: 230px;\n}\n.subcription-count-value {\n  margin-right: 10px;\n  font-weight: 600;\n}\n.form-parallel-display {\n  background: #f1f4f7;\n  border-radius: 5px;\n  padding: 10px;\n  margin-left: 15px;\n  margin-top: 28px;\n}\n\n.subscription-activation label {\n  margin-bottom: 7px;\n}\n.subscription-activation .form-parallel-display label {\n  margin-bottom: 0px;\n}\n.subscription-activate-total {\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  background: #eef8ee;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px dashed #45bd5b;\n}\n.subscription-activate-summary-content {\n  width: 50%;\n  margin: 0 auto;\n  margin-bottom: 15px;\n}\n.subscription-activate-summary-content .ant-row {\n  justify-content: space-between;\n  background: #f4f5f7;\n  padding: 5px 10px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.total-amount.ant-row {\n  padding: 10px;\n  background: #eef8ee;\n  font-weight: 700;\n}\n.apply-coupon-button {\n  margin-top: 28px;\n  margin-left: 15px;\n  height: 38px;\n}\n.coupon-error {\n  font-size: 12px;\n  color: red;\n}\n.subscription-modal .ant-modal-header {\n  background: #021e33;\n}\n.subscription-modal .ant-modal-title,\n.subscription-modal .ant-modal-close-x {\n  color: #0fa0cf;\n}\n.billing-history {\n  margin-top: 15px;\n}\n.billing-history h5 {\n  font-size: 18px;\n  font-weight: 500;\n}\n.subscription-payment-success {\n  text-align: center;\n  padding: 30px;\n}\n.subscription-payment-success .success-image {\n  width: 100px;\n  margin: 0 auto;\n  margin-bottom: 30px;\n}\n.subscription-payment-success .success-text {\n  font-size: 16px;\n}\n.upgrade-card {\n  background: #f5f8f9;\n  padding: 15px 0px;\n  margin-bottom: 10px;\n}\n@media screen and (min-width: 767px) {\n  .md-mt-35 {\n    margin-top: 35px;\n  }\n \n}\n@media screen and (max-width: 991px) {\n  .subscription-count-items {\n    flex-direction: column;\n  }\n}\n@media screen and (max-width: 767px) {\n  .slot-remove-btn{\n    margin-bottom: 30px;\n    display: block!important;\n    text-align: center;\n  }\n  .subscription-content h5 {\n    font-weight: 600;\n    font-size: 14px;\n  }\n  .subscription-content p {\n    font-size: 12px;\n  }\n  .subscription-billing-history .ant-table-tbody > tr > td::before {\n    display: none;\n  }\n  .subscription-billing-history .ant-table-cell {\n    margin-bottom: 10px;\n  }\n  .subscription-activation .ant-row {\n    flex-flow: column;\n  }\n  .subscription-activation .form-parallel-display,\n  .subscription-activation .apply-coupon-button {\n    margin-left: 0px;\n  }\n  .subscription-activation .subscription-activate-summary-content {\n    width: 100%;\n  }\n  .subscription-activation .ant-btn-secondary {\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
